export default {
  en: {
    'save': 'save',
    'auto_save': 'auto save',
    'stop_evaluation_on_start_of_the_week': 'stop evaluation on start of the week',
    'fast_speed': 'fast speed',
    'show_incidents': 'show incidents',
    'match_evaluation': 'match evaluation',
    '': '',
  }
};